export interface WorkArea {
  left: number;
  top: number;
  right: number;
  bottom: number;
  width: number;
  height: number;
}

export function workArea(): WorkArea {
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const left = readCssEnv('safe-area-inset-left');
  const top = readCssEnv('safe-area-inset-top');
  const right = vw - readCssEnv('safe-area-inset-right');
  const bottom = vh - 28 - readCssEnv('safe-area-inset-bottom');
  return { left, top, right, bottom, width: right - left, height: bottom - top };
}

function readCssEnv(inset: string): number {
  const probe = document.getElementById('app');
  if (!probe) return 0;
  const dummy = `env(${inset}, 0px)`;
  const prev = probe.style.paddingLeft;
  probe.style.paddingLeft = dummy;
  const val = parseFloat(getComputedStyle(probe).paddingLeft);
  probe.style.paddingLeft = prev;
  return Number.isFinite(val) ? val : 0;
}

export function clampTitle(x: number, y: number, w: number): { x: number; y: number } {
  const a = workArea();
  const minVisible = 24;
  const nx = Math.min(Math.max(x, a.left - w + minVisible), a.right - minVisible);
  const ny = Math.min(Math.max(y, a.top), a.bottom - minVisible);
  return { x: nx, y: ny };
}
